import { styled } from '@mui/material';
import React, { Children, cloneElement, ReactElement, ReactNode } from 'react';
import { ExpandableContainerProps } from './ExpandableContainer';

interface ExpandableListProps {
  children: ReactNode;
  name: string | null;
}

export const ExpandableList: React.FC<ExpandableListProps> = ({ children, name }) => {
  const childArray = Children.toArray(children) as ReactElement<ExpandableContainerProps>[];
  const nameOccurrences = new Map<string, number>();

  const keyedChildren = childArray.map((child) => {
    const occurrence = nameOccurrences.get(child.props.name) ?? 0;
    nameOccurrences.set(child.props.name, occurrence + 1);

    return cloneElement(child, {
      key: `${child.props.name}__${occurrence}`,
    });
  });

  return (
    <StyledList
      role='list'
      aria-label={name ?? 'Expandable List'}
    >
      {keyedChildren}
    </StyledList>
  );
};

const StyledList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;
